module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"satisfied":"satisfied","dissatisfied":"dissatisfied","neutral":"neutral"},"de":{"satisfied":"zufrieden","dissatisfied":"unzufrieden","neutral":"neutral"},"fr":{"satisfied":"satisfait","dissatisfied":"pas satisfait","neutral":"neutre"},"it":{"satisfied":"soddisfatto","dissatisfied":"insoddisfatto","neutral":"neutrale"}}')
  delete Component.options._Ctor
}
